import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  environment: {
    production: boolean;
  } | null = null;

  constructor() {}

  setEnvironment(env: { production: boolean }) {
    this.environment = env;
  }

  getEnvironment() {
    return this.environment;
  }
}
